import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Container } from "@mui/material";

import { StyledTitle, StyledLink } from "./MFA.styled";

import { Logo, PageTitle } from "@components/common";
import { MFAForm } from "@components/form";
import { Box, Divider, Grid, Paper, Stack } from "@components/base";

const MFA: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box component="main" pt={6}>
      <PageTitle title={t("MFA | Green0Meter")} />

      <Container maxWidth="sm">
        <Paper>
          <Stack direction="column" p={4} rowGap={3}>
            <Stack alignItems="center" direction="column" rowGap={2}>
              <Link to="/login">
                <Logo height={80} width={80} type="green0meter-with-csob" />
              </Link>

              <StyledTitle variant="h4">{t("mfa.connect")}</StyledTitle>
            </Stack>

            <MFAForm />
            <Divider />

            <Grid container spacing={2}>
              <Grid size={4} textAlign="right">
                <StyledLink to="/password-recovery">
                  {t("Forgot password")}
                </StyledLink>
              </Grid>
            </Grid>
          </Stack>
        </Paper>
      </Container>
    </Box>
  );
};

export default MFA;
